import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/console-demo.webp")